<div class="viator-list">
  <div class="viator-list__header">
    <h2>Landmarks & Activities</h2>
    @if(!isFetching) {
      <a href="" (click)="seeAll($event)" class="viator-list__see-all">
        See all
      </a>
    }
  </div>

  <div class="viator-list__content">
    <div class="viator-list__content--description">
      Here are some recommended attractions and sights for you.
    </div>

    <div class="viator-list__content--relative">
      <button class="viator-list__filter" (click)="selectRef.open()">
        <span class="viator-list__filter--label">Select category</span>
        <mat-icon class="viator-list__filter--down" [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
      </button>
      <mat-select (valueChange)="setGroupIndex($event)" #selectRef>
        @for (group of groupViator; track group.type; let index = $index) {
          <mat-option [value]="index">{{ group.type | titlecase }}</mat-option>
        }
      </mat-select>
    </div>

    <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
      <div class="swiper-wrapper">
        @if (isFetching) {
          @for (hotel of [1, 2, 3, 4]; track hotel; let idx = $index) {
            <div class="swiper-slide">
              <app-viator-card-mobile
                [isFetching]="isFetching"
              ></app-viator-card-mobile>
            </div>
          }
        } @else {
          @for (viator of getViatorGroup.events | slice: 0 : 28; track viator.id) {
            <div class="swiper-slide">
              <app-viator-card-mobile
                [viator]="viator"
                [cityId]="cityId"
                [cityName]="cityName"
                [countryName]="countryName"
              ></app-viator-card-mobile>
            </div>
          }
        }
      </div>
      <div class="swiper-pagination"></div>
    </div>

    @if(!isFetching && !getViatorGroup?.events?.length) {
      <app-no-items-found title="EMPTY.VIATOR"></app-no-items-found>
    }
  </div>
</div>
